const getLangDir = (node) => getComputedStyle(node).direction;
export {
  getLangDir
};
